import { createFileRoute, Link } from "@tanstack/react-router";
import { Layout } from "@/components/Layout";

const URL = "https://montessori24.fi/yhteystiedot";
const TITLE = "Yhteystiedot ja yritystiedot | Montessori24";
const DESC =
  "Montessori24.fi:n asiakaspalvelu ja yritystiedot: MLR Solutions Oy, Y-tunnus 3582909-7. Ota yhteyttä sähköpostitse — vastaamme arkipäivisin.";

export const Route = createFileRoute("/yhteystiedot")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: Contact,
});

function Contact() {
  return (
    <Layout>
      <section className="container-prose pt-16 pb-12 md:pt-24">
        <span className="text-xs uppercase tracking-[0.25em] text-muted-foreground">Asiakaspalvelu</span>
        <h1 className="mt-3 max-w-2xl text-5xl text-foreground md:text-6xl text-balance">Ota yhteyttä</h1>
        <p className="mt-6 max-w-xl text-muted-foreground">
          Autamme mielellämme tuotevalinnassa, mitoissa, tilauksissa ja palautuksissa.
        </p>
      </section>

      <section className="container-prose pb-20">
        <div className="grid gap-6 md:grid-cols-2">
          <div className="rounded-3xl border border-border bg-card p-7">
            <h2 className="text-2xl text-foreground">Asiakaspalvelu</h2>
            <dl className="mt-5 space-y-3 text-sm">
              <div>
                <dt className="text-xs uppercase tracking-wider text-muted-foreground">Sähköposti</dt>
                <dd className="mt-1">
                  <a className="text-foreground underline underline-offset-4" href="mailto:asiakaspalvelu@montessori24.fi">
                    asiakaspalvelu@montessori24.fi
                  </a>
                </dd>
              </div>
              <div>
                <dt className="text-xs uppercase tracking-wider text-muted-foreground">Palvelukieli</dt>
                <dd className="mt-1 text-foreground">Suomi, ruotsi ja englanti</dd>
              </div>
            </dl>
            <p className="mt-5 text-sm leading-relaxed text-muted-foreground">
              Pyrimme vastaamaan viesteihin mahdollisimman nopeasti arkipäivisin.
            </p>
          </div>

          <div className="rounded-3xl border border-border bg-cream/60 p-7">
            <h2 className="text-2xl text-foreground">Yritystiedot</h2>
            <dl className="mt-5 space-y-3 text-sm">
              <div>
                <dt className="text-xs uppercase tracking-wider text-muted-foreground">Verkkokauppa</dt>
                <dd className="mt-1 text-foreground">Montessori24.fi</dd>
              </div>
              <div>
                <dt className="text-xs uppercase tracking-wider text-muted-foreground">Yritys</dt>
                <dd className="mt-1 text-foreground">MLR Solutions Oy</dd>
              </div>
              <div>
                <dt className="text-xs uppercase tracking-wider text-muted-foreground">Y-tunnus</dt>
                <dd className="mt-1 text-foreground">3582909-7</dd>
              </div>
              <div>
                <dt className="text-xs uppercase tracking-wider text-muted-foreground">Maa</dt>
                <dd className="mt-1 text-foreground">Suomi</dd>
              </div>
            </dl>
          </div>
        </div>

        <div className="mt-6 rounded-3xl border border-border bg-background p-7">
          <h2 className="text-2xl text-foreground">Kuluttajaneuvonta ja riidanratkaisu</h2>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-muted-foreground">
            Jos erimielisyyttä ei saada ratkaistua neuvottelemalla, kuluttaja voi olla yhteydessä
            kuluttajaneuvontaan. Kuluttaja voi tarvittaessa saattaa asian kuluttajariitalautakunnan
            käsiteltäväksi.
          </p>
          <div className="mt-5 flex flex-wrap gap-3">
            <a
              className="inline-flex items-center rounded-full border border-border px-4 py-2 text-xs font-medium text-foreground transition hover:border-foreground"
              href="https://www.kkv.fi/kuluttaja-asiat/kuluttajaneuvonta/"
              target="_blank"
              rel="noreferrer"
            >
              Kilpailu- ja kuluttajavirasto
            </a>
            <a
              className="inline-flex items-center rounded-full border border-border px-4 py-2 text-xs font-medium text-foreground transition hover:border-foreground"
              href="https://www.kuluttajariita.fi/"
              target="_blank"
              rel="noreferrer"
            >
              Kuluttajariitalautakunta
            </a>
          </div>
        </div>

        <nav aria-label="Lisätiedot" className="mt-8 flex flex-wrap gap-x-6 gap-y-3 text-sm text-muted-foreground">
          <Link className="underline underline-offset-4 hover:text-foreground" to="/toimitus">Toimitus</Link>
          <Link className="underline underline-offset-4 hover:text-foreground" to="/palautus">Palautukset ja peruuttamisoikeus</Link>
          <Link className="underline underline-offset-4 hover:text-foreground" to="/kayttoehdot">Käyttöehdot</Link>
          <Link className="underline underline-offset-4 hover:text-foreground" to="/tietosuoja">Tietosuojaseloste</Link>
          <Link className="underline underline-offset-4 hover:text-foreground" to="/evasteet">Evästeet</Link>
        </nav>
      </section>
    </Layout>
  );
}
